import { usePricingContext } from '@vp/react-pricing-context';
import { ListPrice, Pricing } from '@vp/swan';
import { PriceFromFloat } from '@99designs/design-services-common';
import { VATMessage } from '../VATMessage';
import type { Currency } from '@99designs/design-services-common';
import type { Price as PriceType } from '../../types';

interface PriceProps {
    price?: PriceType;
}

export const Price = ({ price }: PriceProps) => {
    const pricingContext = usePricingContext();

    if (!price) {
        return null;
    }

    const amount = pricingContext?.vatInclusive ? price.listPrice.taxed : price.listPrice.untaxed;

    return (
        <Pricing data-testid="price-container">
            <ListPrice>
                <PriceFromFloat amount={amount} currency={price.currency as Currency} />
            </ListPrice>
            <VATMessage
                market={pricingContext?.market}
                vatInclusive={pricingContext?.vatInclusive}
            />
        </Pricing>
    );
};
